module.exports = __webpack_public_path__ + "img/Qs.962fafeb.png";